import {
  ethers
} from 'ethers'

import * as blockFun from './chain/block'

import store from '../store'

const INFO = {
  // 质押合约
  depositAddress: '0x3eAf96B5659fde8633543712a0CA962c2000eD1C',
  // 用到地abi
  dababi: [
    "function buyWithDistribution(uint256 value) external",
  ],
  // 质押地代币
  usdtAddr: '0x55d398326f99059fF775485246999027B3197955',
  tokenabi: [
    'function transfer( address recipient, uint256 amount ) external returns (bool)',
    'function allowance(address owner, address spender) external view returns (uint256)',
    'function approve(address spender, uint256 amount) external returns (bool)',
    'function balanceOf(address account) external view returns (uint256)',
    'function symbol() external view returns (string memory)',
    'function decimals() external pure returns (uint8)',
  ],

  // withdrawabi: [
  //   'function withdraw(tuple(address token, uint256 amount, address recipient, uint256 deadline, uint256 nonce), uint8 v, bytes32 r, bytes32 s) external',
  // ],
}

// 质押
// useAccount,amount
//useAccount登录的地址
//amount质押的数量必须是字符串
// const deposit = async (useAccount, amount) => {
//   if (!window.ethereum) return {
//     error: true,
//     msg: 'please connect wallet'
//   }
//   console.log('---------1', useAccount);
//   // if (!useAccount) await connectWallet()
//   let provider;
//   if (window.bitkeep && window.bitkeep.ethereum) {
//     console.log('---------3');
//     provider = new ethers.providers.Web3Provider(window.bitkeep.ethereum);
//   } else if (window.ethereum) {
//     console.log('---------4');
//     provider = new ethers.providers.Web3Provider(window.ethereum);
//   } else {
//     console.log('--------5');
//     return;
//   }


//   const signer = provider.getSigner()
//   const token = new ethers.Contract(INFO.usdtAddr, INFO.tokenabi, signer)

//   const allowance = await token.allowance(useAccount, INFO.depositAddress)
//   if (allowance.lt(ethers.utils.parseUnits(amount, 18))) {
//     // const tx = await token.approve(INFO.depositAddress, ethers.constants.MaxUint256)
//     const tx = await token.approve(INFO.depositAddress, ethers.utils.parseUnits(amount, 18))
//     await tx.wait()
//   }

//   const dab = new ethers.Contract(INFO.depositAddress, INFO.dababi, signer)
//   // console.log("dababi:", dab.buyWithDistribution)

//   const tx = await dab.buyWithDistribution(ethers.utils.parseUnits(amount, 18))

//   // tx会返会hash
//   return tx
// }

const deposit = async (useAccount, amount) => {
  if (!window.ethereum) return {
    error: true,
    msg: 'please connect wallet'
  }
  console.log('---------1', useAccount);
  // if (!useAccount) await connectWallet()
  let provider;
  if (window.bitkeep && window.bitkeep.ethereum) {
    console.log('---------3');
    provider = new ethers.providers.Web3Provider(window.bitkeep.ethereum);
  } else if (window.ethereum) {
    console.log('---------4');
    provider = new ethers.providers.Web3Provider(window.ethereum);
  } else {
    console.log('--------5');
    return;
  }

  const signer = provider.getSigner()
  const token = new ethers.Contract(INFO.usdtAddr, INFO.tokenabi, signer)

  // 👇【新增】获取 gas 参数（仅新增这 2 行）
  const feeData = await provider.getFeeData();
  const gasParams = feeData.gasPrice ? { gasPrice: feeData.gasPrice.add(ethers.utils.parseUnits('1', 'gwei')) } : {};

  const allowance = await token.allowance(useAccount, INFO.depositAddress)
  if (allowance.lt(ethers.utils.parseUnits(amount, 18))) {
    // const tx = await token.approve(INFO.depositAddress, ethers.constants.MaxUint256)
    const tx = await token.approve(INFO.depositAddress, ethers.utils.parseUnits(amount, 18), gasParams) // 👈 加 gasParams
    await tx.wait()
  }

  const dab = new ethers.Contract(INFO.depositAddress, INFO.dababi, signer)

  const tx = await dab.buyWithDistribution(ethers.utils.parseUnits(amount, 18), gasParams) // 👈 加 gasParams

  return tx
}


export {
  deposit,

}